import { Component, computed } from '@angular/core';
import { Router } from '@angular/router';
import { UserFilterDto, UserItemDto, UserService, } from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { currentTenantId } from '@/utils/admin-utils';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-admin-user-overview-page',
  styleUrls: ['./tenant-user-overview-page.component.scss'],
  templateUrl: './tenant-user-overview-page.component.html',
})
export class TenantUserOverviewPageComponent {
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateUsers'));
  tenantId = currentTenantId();
  form!: FormGroup;

  readonly loadUsers = (filter: UserFilterDto) => this.userService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: UserFilterDto) => this.userService.getCount({ ...filter, tenantId: this.tenantId() });

  constructor(private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly userService: UserService,
    private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  get queryParams() {
    return { queryParams: { mode: 'tenant' } };
  }

  navigateToUser(user: UserItemDto): void {
    this.router.navigate(['user', user.id], this.queryParams);
  }

  add(): void {
    this.router.navigate(['user', 'new'], this.queryParams);
  }
}
